import md5 from "md5";

export default function toMD5(msg: string): string {
    return md5(msg);
}
